import React from 'react';
import { NavLink } from 'react-router-dom';

const AddTimesheetCrumb = () => (
  <NavLink to="/human-resources/timesheets/add">Add Time Sheet</NavLink>
);

export default AddTimesheetCrumb;
